// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5d7e6c6","239":"04744907","453":"4243f234","732":"16176c0a"}[chunkId] + ".chunk.js";
};